export const testimonials = [
  {
    name: "Dr. Michael R.",
    location: "USA",
    quote: "I finally stopped starting every complex case from a blank page.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/4860e568-7581-47d0-b274-b5b6c48675c3.jpg",
  },
  {
    name: "Dr. Sarah M.",
    location: "Canada",
    quote: "The biggest difference for me was having the problems, objectives and priorities separated. It made the case much easier to organize.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/18f119db-4da6-44a0-b4e3-e22b5f4acba8.jpg",
  },
  {
    name: "Dr. Daniel P.",
    location: "Australia",
    quote: "The visual structure is what makes this different from another orthodontic PDF. I can actually see how the pieces connect.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/1f2a0e74-3f6a-4797-9791-4bfb33b59d1e.jpg",
  },
  {
    name: "Dr. James K.",
    location: "United Kingdom",
    quote: "I particularly liked the Command Center because it gives you one place to review the entire strategy.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/d39769f1-3c1f-4311-a3d3-a119bc2045ca.jpg",
  },
  {
    name: "Dr. Emily T.",
    location: "USA",
    quote: "It helped me stop jumping immediately into mechanics and think about the case more systematically first.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/3c20d450-103a-4905-a340-e36957de7fa0.jpg",
  },
];
